<button *ngIf="rowData.idReport != null && rowData.reportedExaminationsNumber !== null && rowData.reportedExaminationsNumber > 1" class="attached-icon-button se-button-no-ripple"
        [disableRipple]="true"
        mat-icon-button
        matTooltipShowDelay="500"
        matTooltipClass="custom-tooltip"
        #tooltip="matTooltip"
        [matTooltip]="'HasAssociatedExaminations' | translate"
        (click)="onIconClick($event)">
    <mat-icon *ngIf="!loading">attach_file</mat-icon>
    <mat-spinner [title]="spinner" *ngIf="loading"></mat-spinner>
</button>
<div *ngIf="rowData.idReport === null && rowData.examinationsNumber > 1">
    <mat-icon>associations-visit</mat-icon>
</div>
